module.exports = require('./readable').PassThrough



//////////////////
// WEBPACK FOOTER
// ./node_modules/readable-stream/passthrough.js
// module id = /MLu
// module chunks = 0 28 29 100 105 106 107 108 109 110 111 114 115 116